import React from "react";
import { Link } from 'react-router-dom';
import './menu.css'; 

function Menu(){
    // Função para scroll suave
    const handleScroll = (e, targetId) => {
        e.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <nav className="navbar fixed-top navbar-expand-xxl erp-navbar">
            <div className="container">
                <a className="navbar-brand" href="/#">
                    <img src="/imagens/logo_fundo_branco_pequena.png" alt="Logo R6 ERP" width="110" height="40"/>
                </a>
                
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
                        <li className="nav-item">
                            <a className="nav-link botaopagina" href="#banner" onClick={(e) => handleScroll(e, 'banner')}>Página Inicial</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link botaoplanos" href="#planos" onClick={(e) => handleScroll(e, 'planos')}>Planos e Preços</a>
                        </li>
                        
                        {/* BOTÃO "TESTE GRÁTIS" ESTILIZADO */}
                        <li className="nav-item mx-2">
                            {/* Note a mudança para a classe 'btn' e a correção do link para '#planos' */}
                            
                            <Link to="/app/novaconta" className="btn btn-blue">Teste Grátis</Link>
                        </li>

                        {/* BOTÃO "ENTRAR" ESTILIZADO */}
                        <li className="nav-item">
                           <Link to="/app" className="btn btn-entrar">Entrar</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Menu;